import { useState } from 'react';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS } from 'features/command-center/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import { UIStatus } from 'UI/constants/status';

import { getExtraFilters } from '../fallOffsBoard.utils';

export const useFallOffsBoard = () => {
  const [filters, setFilters] = useState({});

  const { state: yearsState } = useFetchWithStatusV2({
    endpoint: `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.productionYearsAvailable}`,
    apiInstance: SECONDARY_API_CLIENT
  });
  const extraFilters = getExtraFilters(yearsState?.results?.years ?? []);

  const handleFiltersChange = selectedFilters => {
    setFilters(selectedFilters);
  };

  return {
    loading: yearsState.status === UIStatus.Loading,
    extraFilters,
    filters,
    handleFiltersChange
  };
};
